module.exports = __webpack_public_path__ + "static/media/btn_apple_ch.0d83fe9c.png";